import { configureStore } from '@reduxjs/toolkit';
import langReducer from './slices/langSlice';
import showMenuReducer from './slices/showMenuSlice';
import pageGetSlugReducer from './slices/pageGetSlugSlice';
import socialMediaGetAllReducer from './slices/socialMediaGetAllSlice';
import menuGroupGetReducer from './slices/menuGroupGetSlice';
import menuGroupGetAllReducer from './slices/menuGroupGetAllSlice';
import settingsGetReducer from './slices/settingsGetSlice';
import seoGetReducer from './slices/seoGetSlice';
import versioningGetReducer from './slices/versioningGetSlice';
import sendMailReducer from './slices/sendMailSlice';

export const store = configureStore({
    reducer: {
        lang: langReducer,
        showMenu: showMenuReducer,
        pageGetSlug: pageGetSlugReducer,
        socialMediaGetAll: socialMediaGetAllReducer,
        menuGroupGet: menuGroupGetReducer,
        menuGroupGetAll: menuGroupGetAllReducer,
        sendMail: sendMailReducer,
        settingsGet: settingsGetReducer,
        seoGet: seoGetReducer,
        versioningGet: versioningGetReducer,
    },
});

export default store;
